export default __webpack_public_path__ + "static/FuturaLT-53b187b42ca229d2a43dac23c5072891.ttf";